<script>
  import { vehicles } from '../store/vehicles.js'
  import { strings } from '../store/store'
  import Form from './components/Form.svelte'
  import CalculatedData from './components/CalculatedData.svelte'
  import Calculator from './components/Calculator.svelte'

  let chosenVehicleType = vehicles[0]
  let chosenEnvClass = chosenVehicleType.environmentalClass[0]

  let distance = null
  let fuelPrice = $strings.defaultDieselPrice

  let load = { direction1: null, direction2: null }
  let fuelConsumption = { direction1: null, direction2: null }

  let direction1Emission = 0,
    direction2Emission = 0,
    direction1EmissionTonDistance = 0,
    direction2EmissionTonDistance = 0,
    specificEmission = 0,
    litersPer100KmDirection1 = 0,
    litersPer100KmDirection2 = 0,
    litersPerDistanceDirection1 = 0,
    litersPerDistanceDirection2 = 0,
    eurosDirection1 = 0,
    eurosDirection2 = 0,
    centPerTonPerKmDirection1 = 0,
    centPerTonPerKmDirection2 = 0,
    centPerTonPerKm = 0,
    centPerTon = 0,
    count

  const getCalculatedEmissions = () => {
    count()
  }
</script>

<div class="calculator-app">
  <Form
    bind:chosenVehicleType
    bind:chosenEnvClass
    bind:distance
    bind:fuelPrice
    bind:load
    bind:fuelConsumption
    {getCalculatedEmissions}
  />

  <Calculator
    {chosenVehicleType}
    {chosenEnvClass}
    {distance}
    {load}
    {fuelConsumption}
    {fuelPrice}
    bind:direction1Emission
    bind:direction2Emission
    bind:direction1EmissionTonDistance
    bind:direction2EmissionTonDistance
    bind:specificEmission
    bind:litersPer100KmDirection1
    bind:litersPer100KmDirection2
    bind:litersPerDistanceDirection1
    bind:litersPerDistanceDirection2
    bind:eurosDirection1
    bind:eurosDirection2
    bind:centPerTonPerKmDirection1
    bind:centPerTonPerKmDirection2
    bind:centPerTonPerKm
    bind:centPerTon
    bind:count
  />

  <CalculatedData
    {direction1Emission}
    {direction2Emission}
    {direction1EmissionTonDistance}
    {direction2EmissionTonDistance}
    {specificEmission}
    {litersPer100KmDirection1}
    {litersPer100KmDirection2}
    {litersPerDistanceDirection1}
    {litersPerDistanceDirection2}
    {eurosDirection1}
    {eurosDirection2}
    {centPerTonPerKmDirection1}
    {centPerTonPerKmDirection2}
    {centPerTonPerKm}
    {centPerTon}
  />
</div>

<style>
  .calculator-app {
    max-width: 855px;
  }
</style>
